export const GET_USER_DATA = 'user/data/get';
export const GET_USER_POINTS = 'user/points/get'
export const GET_USER_TICKETS = 'user/tickets/get';
export const GET_USER_SUBSCRIPTIONS = 'user/subscriptions/get';
export const CHANGE_USER_PIN = 'user/pin/change';